import React, {useRef, useState} from "react";
import Practic from "./components/Practic/Practic";
import "./styles/components.css";

function App() {
  return (
    <div className="App">
    <Practic/>
    </div>
  );
}

export default App;
